<template>
  <div class="login-wrapper">
    <van-nav-bar title="微信登录" />
    <div class="login-content">
      <van-loading v-if="loading" type="spinner" size="24px">登录中...</van-loading>
      <div v-else-if="error" class="error-message">
        <van-icon name="warning-o" size="48px" color="#ee0a24" />
        <p>{{ error }}</p>
        <van-button type="primary" @click="retryLogin">重试</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { GetWxUserFromCode } from '@/api/tutoringAgency';

export default {
  name: 'WechatLogin',
  data() {
    return {
      loading: true,
      error: ''
    }
  },
  created() {
    this.handleWechatLogin();
  },
  methods: {
    async handleWechatLogin() {
      try {
        // 从URL中获取code参数
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        console.log("code:", code)
        
        if (!code) {
          this.error = '授权失败：未获取到授权码';
          this.loading = false;
          return;
        }

        // 调用接口获取用户信息
        const response = await GetWxUserFromCode(code);
        
        // 保存用户信息到全局状态
        this.$store.commit('setUserInfo', response.data);
        
        // 跳转到原始目标页面
        const redirectUrl = this.$route.query.redirect;
        if (redirectUrl) {
          this.$router.replace(redirectUrl);
        } else {
          // 如果没有redirect参数，跳转到首页
          this.$router.replace('/');
        }
        
      } catch (error) {
        console.error('微信登录失败:', error);
        this.error = '登录失败，请重试';
        this.loading = false;
      }
    },
    retryLogin() {
      this.loading = true;
      this.error = '';
      this.handleWechatLogin();
    }
  }
}
</script>

<style scoped>
.login-wrapper {
  min-height: 100vh;
  background: #f7f8fa;
}

.login-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  padding: 20px;
}

.error-message {
  text-align: center;
  color: #646566;
}

.error-message p {
  margin: 16px 0;
  font-size: 16px;
}
</style> 